module.exports = __webpack_public_path__ + "img/aro-kraken-ant.d5e3c4cc.png";